export type GetUserProfessionalDetailQuerySuccessResponseKeys =
  | 'job_role_name'
  | 'job_role_id'
  | 'other_job_role_name'
  | 'higher_education_course_type'
  | 'have_work_experience';

const allUserProfessionalDetailQuerySuccessKeys: GetUserProfessionalDetailQuerySuccessResponseKeys[] =
  [
    'job_role_name',
    'job_role_id',
    'other_job_role_name',
    'higher_education_course_type',
    'have_work_experience'
  ];

const getUserProfessionalDetailQuery = (
  successKeys: GetUserProfessionalDetailQuerySuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length
    ? successKeys
    : allUserProfessionalDetailQuerySuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserProfessionalDetails {
      user_professional_details {
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_professional_details{
      ${successFields}
      ${failureFields}
    }
  `;
};

export { getUserProfessionalDetailQuery };
